import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Card,Pagination,Input } from 'antd';
import getPrayersByOrg from '../../hooks/getPrayersByOrg';
import useFetchCities from '../../hooks/fetchCities';
import { app } from '../../config';
import { EditTwoTone } from '@ant-design/icons';


const States = () => {
  const { t } = useTranslation(['common']);
  const { Search } = Input;
  const [states,setStates] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [commonData, setCommonData] = useState([]);
  const [renderList,setRenderList] = useState([]);
  const [current, setCurrent] = useState(1);
  let navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem('user'));
  console.log(user);
  const c=useFetchCities()
  // console.log(c)
  // const cities=c.response?c.response.data:[];
  // const citiesCount=c.response?c.response.data.length:0
  useEffect(() => {
    const fetchEvents=async()=>{
      const limit=6;
      const offset=0;
      const c=await axios.get(`${app.URL}/state/viewdetail`);
      console.log(c);
      console.log(c.data.data)
      c.data?setStates(c.data.data):[];
      c.data?setRenderList(c.data.data.slice(0,10)):[];
      c.data?setPagesCount(c.data.data.length):[];
      c.data?setCommonData(c.data.data):[];
      
      }
      fetchEvents();

  }, []);
  const p=getPrayersByOrg(user.organizationId);
  console.log(p);
  let prayers=p.response?p.response.data:[];
  console.log(prayers);
  const addState=(e)=>{
    console.log(e);
    navigate('/state/add',{replace:true});
}
const editState = (e) => {
  console.log(e);
  localStorage.setItem('stateId', JSON.stringify(e.stateId));
  navigate('/state/edit', { replace: true });
};
const onSearch = async (value) => {
  console.log(value);
  try {
    const result = await axios.get(`${app.URL}/state/search/${value}`);
    console.log(result.data.data);
    result.data ? setCommonData(result.data.data) : [];
    result.data ? setRenderList(result.data.data.slice(0, 10)) : [];
    result.data ? setPagesCount(result.data.data.length) : 0;

  } catch (e) {
    console.log('Error');
    console.log(e);
    if (e.message) setErr(e.response.data.message);
    setTableShow(false);
  }



}
const handleSearchChange = (e) => {
  console.log(e.target.value);
  if (!e.target.value) {
    setRenderList(states.slice(0,10));
    setCommonData(states);
    setCurrent(1)
    setPagesCount(states.length);
  }
};
const onChange = async (page, pageSize) => {
  console.log(page, pageSize);
  setCurrent(page);
  if (!page) page = 1;
  let limit = pageSize;
  let reqObj = {
    limit,
    offset: limit * (page - 1),
  };
  console.log(reqObj);
  setRenderList(commonData.slice(reqObj.offset, reqObj.offset + limit));
};

  return (
    // <div class='container colorbg m-0 pl-0' style={{ maxWidth: '100%' }}>
    //   <div class='row'>
    //     <OrgNav />
    //   </div>
    //   <div class='row '>
    //     <div class='col-sm-3' style={{ width: '25%', marginLeft: '0px' }}>
    //       <SideBar4 />
    //     </div>
    //     {/* <div class="col-lg-6 mt-4 "> */}
    //     <div class='container w-75'>
    //       <div class='row'>
    //         <div class='col mt-3'>
    //           <div class='input-group ml-60' style={{ width: '40%' }}>
    //             <input type='search' class='form-control rounded w-50' placeholder='Search' aria-label='Search' aria-describedby='search-addon' />
    //             <button type='button' class='btn btn-outline-primary color1 button text-white'>
    //               search
    //             </button>
    //           </div>
    //         </div>
    //       </div>
    //       <div class='row'>
    //         <div class="col-lg-6 fs-3 fw-bold"> <div class="mt-3"> {t('Prayers')} </div></div>
    //         <div class="col-lg-5 mt-3 text-right"><button class="btn btn-primary button" onClick={addPrayer}>Add Prayer</button></div>
    //         </div>
    //         <div class="row">
    //       {prayers?prayers.map((prayer)=>{
    //         console.log(prayer)
    //         return(

    //           <div key={prayer.prayarTimeId} class='col-lg-4 text-black mt-3 mb-3 '>
    //           <Card
    //             title={<h1 class="fw-bold">{prayer.prayer}</h1>}
    //             bordered={false}
    //             style={{
    //               width: 300, 
    //               maxHeight:400,
    //               wordWrap:'break-word',
    //               fontSize:14,
                  
    //               // inlineSize:"250px"
    //             }}
    //             class="tbl mt-3"
    //           >
    //              {/* <p><b class='fw-bold'>Start Date:</b> {event.startDate.slice(0,10)}</p>
    //              <p><b class='fw-bold'>End Date:</b> {event.startDate.slice(0,10)}</p> */}
    //              <p><b class='fw-bold'>Start Time:</b> {prayer.startTime} </p>
    //              <p><b class='fw-bold'>End Time:</b>{prayer.endTime}</p>
    //             {/* <p style={{overflow:"hidden"}}>{event.description.slice(0,90)}</p> */}
    //             <button class="btn btn-primary button mt-3" onClick={() => editPrayer(prayer)}>Edit</button>
    //           </Card>
    //           </div>
    //         )
               
    //       }):""}
       
            
    //    </div>
    //     </div>
    //   </div>
    //   {/* </div> */}
    // </div>
    // <div className='row w-100'>
    // <Navbar />
    // <div className='col-lg-3 col-md-4 col-sm-12'>
    //   <NewSideBar />
    // </div>

    <div className='ml-3 col-lg-12 col-md-12 col-sm-12'>
      <div className='row text-center mt-4'>
        <div className='col-lg-7 col-md-12 col-sm-12'>
          <Search
          className='search'
            placeholder='Search by State/ Country'
            onSearch={onSearch}
            onChange={handleSearchChange}
            style={{
              width: 300,
            }}
          />
        </div>
      </div>
      <div className='row'>
      <div className='row mt-2'>
    <div className="col-lg-6 col-md-10 col-sm-10 fs-3 fw-bold">
    {t('States')}
    </div>
    <div className="col-lg-2 col-md-2 col-sm-2">
    <button class="btn btn-primary button" onClick={addState}>Add State</button>  
    </div>  
    </div>
      </div>
      {/* <div className='row'>
      {renderList?renderList.map((state)=>{
            
            return(

              <div key={state.stateId} class='col-lg-4 col-md-6 col-sm-12 text-black mt-3 mb-3 '>
              <Card
                title={<h1 class="fw-bold">{state.state}</h1>}
                bordered={false}
                style={{
                  width: 250, 
                  maxHeight:300,
                  wordWrap:'break-word',
                  fontSize:14,

                }}
                class="tbl mt-3"
              >

                 <p><b class='fw-bold'>Country:</b>{state.country}</p>
                 <p><b class='fw-bold'>Status: </b>{state.status==="Inactive"?<span style={{color:"red"}}>{state.status}</span>:<span>{state.status}</span>}</p>
                 <EditTwoTone
                    className='mt-2'
                    displayName='edit'
                    twoToneColor='blue'
                    style={{ fontSize: '25px' }}
                    onClick={() => {
                      editState(state);
                    }}
                  />
              </Card>
              </div>
            )
               
          }):""}
       
      </div> */}
       <div className='col-lg-7 col-md-12 col-sm-12 '>
      <div class=' styled-table '>
         <table class='table text-black' >
           <thead class='thead-light'>
             <tr>
             <th>{t("ID")}</th>
                             <th>{t("State")}</th>
                             <th>{t("Country ")}</th>
                             <th>{t("Status")}</th>
                             <th> </th>
             </tr>
           </thead>
           <tbody >

             {renderList
               ? renderList.map((output) => (

                   <tr className='row-hover' onClick={() => editState(output)}>
                     <td style={{width:"160px"}}>{output.stateId}</td>
                     {/* onClick={()=>{editUser(output)}} style={{color:"blue",textDecoration:"underline", width:"160px"}} */}
                     <td style={{width:"200px"}} >{output.state?output.state :"null"}</td>
                     <td style={{width:"200px"}}>{output.country}</td>
                     <td style={{width:"200px"}}>{output.status}</td>
                     {/* <td style={{width:"160px"}}>{output.phone}</td>
                   <td style={{width:"160px"}}>{output.userType==="A"?"Admin":output.userType==="D"?"Donor":output.userType==="O"?"Org User":"User"}</td> */}
                     <td>
                     <EditTwoTone displayName="edit" twoToneColor="blue" style={{fontSize:"20px"}} onClick={() => editState(output)} />
                       {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
                         {t('Edit')}
                       </button> */}
                     </td>
                   </tr>
                 ))
               : ' '}
           </tbody>
         </table>
       </div>     
  </div>
      <Pagination style={{marginTop:"10px"}} onChange={onChange} defaultCurrent={current} pageSize={10} total={pagesCount} />  
    </div>
  // </div>
  );
};

export default States;
